import { computed } from 'vue'
import { FeatureList, useLDFlag } from '@/lib/ldClient.ts'
import { useModalStore } from '@/store/pinia/ModalStore.ts'
import PaymentModal from '@/app/components/modals/PaymentModal.vue'

export function useFreemium() {
  const flag = useLDFlag(FeatureList.ENABLE_FREEMIUM)
  const freemiumEnabled = computed(() => !!flag.value)
  const showPaymentModal = () =>
    useModalStore().openModal(PaymentModal, {}, 'extra-large', false, {
      'max-height': '100vh',
      background: 'white',
    })

  return {
    freemiumEnabled,
    showPaymentModal,
  }
}
